(function () {
  'use strict';
  if (window.__jlcPolaireGiftSyncLoaded) return;
  window.__jlcPolaireGiftSyncLoaded = true;

  var giftVariantId = 66203783266653;
  var packVariants = new Set([66170065060189, 66170065092957]);
  var maxGiftsPerOrder = 20;
  var giftMarker = '_jlc_polaire_gift';
  var upsellVariantId = 66241284473181;
  var upsellEligible = new Set([66169925009757, 66204673605981, 66170065060189, 66170065092957]); // 1 collant, duo, 2 + 1, 3 + 2 // « Collant supplémentaire (offre panier) » : jamais plus que le nombre de packs
  var running = null;
  var timer = null;
  var lastErrorAt = 0;

  function base() {
    var path = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return path.charAt(path.length - 1) === '/' ? path : path + '/';
  }

  async function request(path, options) {
    var response = await fetch(base() + path + '?eira_offer_builder=1', Object.assign({
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    }, options || {}));
    if (!response.ok) {
      var details = '';
      try { details = JSON.stringify(await response.json()); } catch (error) { details = response.statusText; }
      throw new Error('Panier ' + response.status + ': ' + details);
    }
    return response.json();
  }

  function quantityOf(item) {
    return Math.max(0, Math.floor(Number(item && item.quantity) || 0));
  }

  function taggedGift(item) {
    return Number(item.variant_id) === giftVariantId && String((item.properties || {})[giftMarker] || '') === '1';
  }

  function targetState(cart) {
    var eligible = 0;
    var standaloneGifts = 0;
    var linkedGifts = [];
    (cart.items || []).forEach(function (item) {
      if (packVariants.has(Number(item.variant_id))) eligible += quantityOf(item);
      if (Number(item.variant_id) === giftVariantId) {
        if (taggedGift(item)) linkedGifts.push(item);
        else standaloneGifts += quantityOf(item);
      }
    });
    return {
      target: Math.max(0, Math.min(maxGiftsPerOrder, eligible - standaloneGifts)),
      linked: linkedGifts
    };
  }

  async function trimUpsell(cart) {
    var packs = 0, ups = [];
    (cart.items || []).forEach(function (item) {
      if (upsellEligible.has(Number(item.variant_id))) packs += quantityOf(item);
      if (Number(item.variant_id) === upsellVariantId) ups.push(item);
    });
    var extra = ups.reduce(function (sum, item) { return sum + quantityOf(item); }, 0) - packs;
    if (extra <= 0) return false;
    var updates = {};
    ups.slice().reverse().forEach(function (item) {
      if (extra <= 0) return;
      var step = Math.min(extra, quantityOf(item));
      updates[item.key] = quantityOf(item) - step;
      extra -= step;
    });
    await request('cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    });
    return true;
  }

  async function reconcile() {
    var cart = await request('cart.js');
    if (await trimUpsell(cart)) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      cart = await request('cart.js');
    }
    var state = targetState(cart);
    var existing = state.linked.reduce(function (sum, item) { return sum + quantityOf(item); }, 0);
    if (existing === state.target) return false;

    if (existing > state.target) {
      var remove = existing - state.target;
      var updates = {};
      state.linked.slice().reverse().forEach(function (item) {
        if (remove <= 0) return;
        var step = Math.min(remove, quantityOf(item));
        updates[item.key] = quantityOf(item) - step;
        remove -= step;
      });
      await request('cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: updates })
      });
    } else {
      await request('cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{
            id: giftVariantId,
            quantity: state.target - existing,
            properties: { _jlc_polaire_gift: '1' }
          }]
        })
      });
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return true;
  }

  function sync() {
    if (running) return running;
    running = reconcile().catch(function (error) {
      if (Date.now() - lastErrorAt > 20000) {
        lastErrorAt = Date.now();
        console.warn('Le cadeau du Joli Collant sera resynchronisé lors du prochain changement de panier.', error);
      }
      return false;
    }).finally(function () { running = null; });
    return running;
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(sync, typeof delay === 'number' ? delay : 160);
  }

  document.documentElement.addEventListener('cart:change', function () { schedule(75); });
  document.documentElement.addEventListener('cart:refresh', function () { schedule(350); });
  window.addEventListener('pageshow', function () { schedule(120); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(160); }, { once: true });
  } else {
    schedule(160);
  }
})();
